import React, { useState, useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const StatsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const stats = [
    { id: 1, value: 2000, suffix: '+', label: 'Projects Completed' },
    { id: 2, value: 5, suffix: '', label: 'Years of experience' },
    { id: 3, value: 4, suffix: '', label: 'Regional offices' },
    { id: 4, value: 20, suffix: '+', label: 'Team members' }
  ];

  const Counter = ({ value, suffix }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (isInView) {
        const duration = 2000;
        const steps = 60;
        const increment = value / steps;
        let current = 0;

        const timer = setInterval(() => {
          current += increment;
          if (current >= value) {
            setCount(value);
            clearInterval(timer);
          } else {
            setCount(Math.floor(current));
          }
        }, duration / steps);

        return () => clearInterval(timer);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return <span>{count}{suffix}</span>;
  };

  return (
    <section className="stats-arch04" ref={ref}>
      <div className="stats-arch04-container">
        <motion.h2 
          className="stats-arch04-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Innovate. Create. Elevate.
        </motion.h2>

        <div className="stats-arch04-grid">
          {stats.map((stat, index) => (
            <motion.div 
              key={stat.id}
              className="stats-arch04-item"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <span className="stats-arch04-label">{stat.label}</span>
              <span className="stats-arch04-value">
                <Counter value={stat.value} suffix={stat.suffix} />
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
